// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';

import notifications from 'notifications';
import {miniSpacingRight, miniSpacingLeft} from 'styles/Utilities';
import getTestProps from 'test/lib/cypress/getTestProps';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import DragDropUpload from 'util/DragDropUpload';
import {splitExtension} from 'util/FileUtil';

/**
 * Exported for testing
 * @package
 */
export function handleDrop(
  _e: React.DragEvent,
  files: FileList,
  addFiles: (files: FileList) => void,
  accept?: string
): void {
  const acceptedExtensionsAndMimeTypes =
    accept
      ?.split(',')
      .map((s) => s.trim())
      .filter((s) => s) ?? [];

  if (
    acceptedExtensionsAndMimeTypes.length &&
    !Array.from(files).every(
      // The file's extension or the MIME type should be accepted
      (file: File) =>
        acceptedExtensionsAndMimeTypes.includes(splitExtension(file.name).extension) ||
        acceptedExtensionsAndMimeTypes.includes(file.type)
    )
  ) {
    notifications.error(`Please upload a supported file. The uploaded file's extension is not supported.`);
    return;
  }

  addFiles(files);
}

export interface FileChooserProps {
  className?: string;
  multiple: boolean;
  /**
   * When multiple is true, callback should accept a variable number of `File` args; if false then
   * it only needs to accept a single `File` arg.
   */
  onSelectFiles: (...args: Array<File>) => void;
  /**
   * Comma separated list of file extensions or MIME types to accept. e.g. ".csv, application/vnd.ms-excel"
   * An empty string or null value will allow any file type to be uploaded.
   */
  accept?: string;
}

class FileChooser extends React.Component<FileChooserProps> {
  static defaultProps = {
    multiple: false,
  };

  fileInputRef = React.createRef<HTMLInputElement>();

  override componentDidMount(): void {
    DragDropUpload.push(ReactDOM.findDOMNode(this) as HTMLElement);
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    $(ReactDOM.findDOMNode(this)!).on('filedrop.filechooser', (e: React.DragEvent, files: FilesList) => {
      handleDrop(
        e,
        files,
        (files) => {
          this._addFiles(files);
        },
        this.props.accept
      );
    });
  }

  override componentWillUnmount(): void {
    $(ReactDOM.findDOMNode(this)!).off('.filechooser');
    DragDropUpload.pop(ReactDOM.findDOMNode(this) as HTMLElement);
  }

  addFromChooser = (e: React.ChangeEvent<HTMLInputElement>): void => {
    this._addFiles(e.target.files!);
  };

  clickFile = (): void => {
    $(ReactDOM.findDOMNode(this.fileInputRef.current)!).click();
  };

  _addFiles = (files: FileList | Array<File>): void => {
    if (!this.props.multiple && files.length > 1) {
      notifications.error(`Please upload only one file. \
Multiple file upload is not supported for this input.`);
      return;
    }
    this.props.onSelectFiles(...Array.from(files || []));
  };

  override render(): JSX.Element {
    return (
      <div className={classNames('drop-help', this.props.className)}>
        <input
          type="file"
          multiple={this.props.multiple}
          className="hidden"
          ref={this.fileInputRef}
          onChange={this.addFromChooser}
          accept={this.props.accept}
          {...getTestProps({component: 'FileChooser', element: 'fileInput'})}
        />
        <BenchlingIcon icon="cloud-arrow-up" className={css(styles.cloudUploadIcon)} />
        <span className="instructions">Drag and drop to upload or </span>
        <Button
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          className={classNames('drop-help-btn', css(styles.chooseFileButton))}
          onClick={this.clickFile}
          size={ButtonSize.SMALL}
          text={this.props.multiple ? 'Choose files' : 'Choose a file'}
        />
      </div>
    );
  }
}

const styles = StyleSheet.create({
  cloudUploadIcon: miniSpacingRight,
  chooseFileButton: miniSpacingLeft,
});

export default FileChooser;
